import React from "react";
import { useNavigate } from "react-router-dom";
import inggage from "../../assets/inggage.png";
import creator from "../../assets/images/creator.png";
import brand from "../../assets/images/brand.png";

const SignupRole = () => {
  const navigate = useNavigate();

  const handleRoleSelect = (role) => {
    localStorage.setItem("userType", role);
    navigate("/signup", { state: { userType: role } });
  };

  return (
    <div className="flex md:flex-row xs:flex-col items-center justify-center my-20 signuprole " style={{fontFamily:"Gilroy-Medium"}}>

      <div className="md:w-1/2 xs:w-full flex items-center justify-center">
        <img src={inggage} alt="formimage" className="w-3/4 h-3/4" />
      </div>

      <div className="md:w-1/2 xs:w-full flex flex-row items-center justify-center">
        <div
          onClick={() => handleRoleSelect("Influencer")}
          className="flex flex-col items-center justify-center md:w-1/2 md:h-1/2 xs:w-full xs:h-full md:p-8 xs:p-2 cursor-pointer hover:-translate-y-2 transition-transform duration-300"
        >
          <img src={creator} alt="creator" />
          <p className="text-black text-2xl ">Creator</p>
        </div>
        <div
          onClick={() => handleRoleSelect("Brand")}
          className="flex flex-col items-center justify-center md:w-1/2 md:h-1/2 xs:w-full xs:h-full md:p-8 xs:p-2 cursor-pointer hover:-translate-y-2 transition-transform duration-300"
        >
          <img src={brand} alt="brand" />
          <p className="text-black text-2xl ">Brand</p>
        </div>
      </div>

    </div>
  );
};

export default SignupRole;
